module.exports = __webpack_public_path__ + "static/media/sk.8fff59a6.svg";